export const PARTNERS_API_URL = 'ui/partner/partners';

export const OPERATOR_API_URL = 'ui/operator/partners';
